import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class MissingImportsReportCriteria extends ValueObject  
{
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";

    public date: Date = new Date();
}